import { io } from "socket.io-client";

// export const socket = io("https://droplet-api.fjcr.pro/", {           //MASTER
export const socket = io("https://test-api.fjcr.pro/", {                 //HANDMOL
//export const socket = io("http://localhost:5050", {                     //LOCAL
  // export const socket = io("https://test-api.molecularwebxr.org", {     //HANDMOL EN PAPERSPACE
  transports: ["websocket", "polling"],
  autoConnect: false,
  closeOnBeforeunload: false,
});
